<template>
  <div style="margin-top: 67px;">
    <step :isActiveComplete="true"></step>
    <div class="complete-wrapper">
      <b-container>
        <b-row>
          <b-col sm="11" md="6" offset-md="3">
            <p class="main-text bold">체험 신청이 성공적으로 완료되었습니다</p>
            <!-- <router-link :to="{ name: 'Promotion' }">20% 할인 프로모션 참여하기</router-link> -->
            <div class="apply-info-wrapper">
              <span class="main-title-text">추천인 휴대폰 번호</span>
              <div>
                <input type="text" v-model="recommenderPhoneNumber">
                <button id="recommend-btn" @click="enrollRecommender">등록</button>
              </div>
              <router-link :to="{ name: 'Cash' }">
                <p class="recommend-text">추천해준 친구의 전화번호를 입력하면 10% 즉시할인</p>
                <!-- <p class="recommend-text">{{customerName}}님에게는 10%만큼의 I/O Cash를 드립니다.</p> -->
              </router-link>
            </div>
            <div class="apply-info-wrapper">
              <span class="main-title-text">신청내역</span>
              <div class="apply-list">
                <div v-for="(item, index) in cartItems" :key="index" class="cart-item">
                  <div class="left-item-info">
                    <img style="width: 45px;" :src="item.iconUrl">
                    <span>{{item.name}}</span>
                  </div>
                  <span>{{item.price}}원</span>
                </div>
              </div>
            </div>
            <div class="apply-info-wrapper">
              <div class="header-text">
                <span class="main-title-text">체험 플랜</span>
                <span style="font-size: 12px;">*1년 무상 교환 및 A/S, 무료체험 중 언제든 무료 반품</span>
              </div>
              <div class="info">
                <img style="width: 40px; height: 30px;" src="@/assets/complete/icon-plan-a.png" alt>
                <div>
                  <p>한달 무료 체험 후</p>
                  <span>
                    <img
                      style="width: 14px; height: 13px; margin-right: 3px;"
                      src="@/assets/complete/icon-cal.png"
                    >
                    {{firstPayAtYear}}년 {{firstPayAtMonth}}월 {{firstPayAtDay}}일
                  </span>
                  <br>
                  <span>
                    <img
                      style="width: 14px; height: 13px; margin-right: 3px;"
                      src="@/assets/complete/icon-pay.png"
                    >
                    {{amount}}원 {{paymentMethod}}
                  </span>
                </div>
              </div>
            </div>
            <div class="apply-info-wrapper address-info">
              <span class="main-title-text">배송지 정보</span>
              <div class="info">
                <img style="width: 48px; height: 26px;" src="@/assets/complete/icon-delivery.png">
                <div>
                  <p>{{customerName}}</p>
                  <span>{{phoneNumber}} |</span>
                  <span>{{address}}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <suggestion v-show="suggestions.length"></suggestion>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Step from './Step'
import AppFooter from '../AppFooter'
import Suggestion from './cart/Suggestion'
import { findMainAddress } from '../../modules/modules'
import { convertPaymentMethodInKorBy, PAYMENT_METHOD_BY_NUM } from '../../modules/payment_methods'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'complete',
  components: { Step, AppFooter, Suggestion },
  data () {
    return {
      firstPayAtYear: '',
      firstPayAtMonth: '',
      firstPayAtDay: '',
      customerName: '',
      phoneNumber: '',
      address: '',
      paymentMethod: '',
      amount: '',
      recommenderPhoneNumber: ''
    }
  },
  async mounted () {
    this.firstPayAtYear = this.firstPayAt.split('-')[0]
    this.firstPayAtMonth = this.firstPayAt.split('-')[1]
    this.firstPayAtDay = this.firstPayAt.split('-')[2]

    let customerInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/customers/' + this.applicant.customerId + '/')
    this.customerName = customerInfo.data.name
    this.phoneNumber = customerInfo.data.phone_number
    let addressInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/addresses/?search=' + this.applicant.customerId)
    let index = findMainAddress(addressInfo.data)
    this.address = addressInfo.data[index].main_address + ' ' + addressInfo.data[index].sub_address
    this.paymentMethod = convertPaymentMethodInKorBy(this.applicant.paymentMethod)
    if (this.applicant.paymentMethod === PAYMENT_METHOD_BY_NUM.LEASE) {
      this.amount = this.$store.state.leaseAmount
    } else if (this.applicant.paymentMethod === PAYMENT_METHOD_BY_NUM.LUMP_SUM) {
      this.amount = this.$store.state.amount
    }
  },
  computed: {
    cartItems () {
      return this.$store.state.cartItems
    },
    suggestions () {
      return this.$store.state.suggestions
    },
    applicant () {
      return this.$store.state.applicant
    },
    applicantProducts () {
      return this.$store.state.applicantProducts
    },
    firstPayAt () {
      return this.$store.state.firstPayAt
    },
    deliveryAt () {
      return this.$store.state.deliveryAt
    }
  },
  methods: {
    async enrollRecommender () {
      if (this.recommenderPhoneNumber === '') {
        this.$dialogs.alert('추천인의 휴대폰 번호를 입력해주세요..', alertOptions)
        return
      }
      let recommender = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/customers/?search=' + this.recommenderPhoneNumber)
      if (recommender.data.length === 0) {
        this.$dialogs.alert('추천인이 I/O 고객이 아닙니다.', alertOptions)
        return
      }
      let data = new FormData()
      data.append('recommender', recommender.data[0].id)
      data.append('recommendee', this.applicant.customerId)
      await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/customers/recommendations/', data)
        .then((result) => {
          if (result.status === 201) {
            this.$dialogs.alert('추천인을 등록하였습니다!', alertOptions)
            this.recommenderPhoneNumber = ''
          }
        })
        .catch((error) => {
          if (error.response.data.code === 126) {
            this.$dialogs.alert('죄송합니다. 이미 추천인을 등록하셨습니다.', alertOptions)
          } else if (error.response.data.code === 21) {
            this.$dialogs.alert('죄송합니다. 추천인 등록에 실패했습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
    }
  }
}
</script>

<style scoped>

.complete-wrapper {
  background-color: #fafafa;
}

.main-text {
  margin-top: 40px;
  font-size: 20px;
}
.apply-info-wrapper {
  margin-top: 50px;
  text-align: left;
  font-size: 14px;
}

.apply-info-wrapper span {
  font-size: 14px;
  letter-spacing: 0;
  display: inline-flex;
  align-items: center;
}

.header-text {
  display: flex;
  justify-content: space-between;
}
.apply-list {
  border-top: solid 1px #8c9296;
  border-bottom: solid 1px #8c9296;
}
.cart-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}
.left-item-info {
  display: flex;
  align-items: center;
}
.left-item-info span {
  margin-left: 20px;
  font-weight: bold;
}

.info {
  border-top: solid 1px #8c9296;
  border-bottom: solid 1px #8c9296;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.info p {
  margin: 0;
}
.info div {
  margin-left: 20px;
}

.address-info {
  margin-bottom: 60px;
}

.main-title-text {
  display: block;
  margin-bottom: 6px;
}

input {
  height: 100%;
  padding: 5px;
  width: 80%;
  border: solid 1px #eef0f1;
  border-radius: 2px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

#recommend-btn {
  border-radius: 2px;
  background-color: #dee2e5;
  font-size: 14px;
  letter-spacing: -0.4px;
  color: #3d4953;
  border: 0;
  height: 100%;
  width: 18%;
  padding: 5px;
  cursor: pointer;
  float: right;
}

.promotion-text {
  color: #6f97fa;
  font-size: 12px;
  text-decoration: underline;
  margin: 0;
}

.recommend-text {
  color: #6f97fa;
  font-size: 8px;
  text-decoration: underline;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/apply/Complete.vue